import { createApp } from 'vue'
import App from './App.vue'

// Importa o Vuetify e seus estilos
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Importa o CSS do Material Design Icons
import '@mdi/font/css/materialdesignicons.css'
import 'aos/dist/aos.css'

// Importa os aliases e o conjunto mdi do Vuetify
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Configuração do Vuetify com os ícones
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// Cria e monta a aplicação
createApp(App)
  .use(vuetify)
  .mount('#app')
